module.exports = __webpack_public_path__ + "static/media/space_icon.1bbfb7d5.svg";